import React from 'react';
import { Navigate } from 'react-router';
import { ShieldAlert } from 'lucide-react';
import '../styles/role-guard.css';

const RoleGuard = ({ allowedRoles = ['ADMIN', 'Super Admin'], children }) => {
  const token = localStorage.getItem('access_token');

  if (!token) {
    return <Navigate to="/signin" replace />;
  }

  const getSafeRole = () => {
    try {
      const directRole = localStorage.getItem('role');
      if (directRole) {
        const cleaned = directRole.replace(/^["']|["']$/g, '');
        return cleaned;
      }
      const userStr = localStorage.getItem('user');
      if (userStr) {
        const userObj = JSON.parse(userStr);
        if (userObj?.role) return userObj.role;
      }
    } catch (e) {
      console.error('Error determining user role in RoleGuard:', e);
    }
    return 'user';
  };

  const userRole = getSafeRole();
  const hasAccess = allowedRoles.some(
    (role) => role.toLowerCase() === userRole.toLowerCase()
  );

  if (!hasAccess) {
    return (
      <div className="role-guard-container">
        <div className="role-guard-card">
          <ShieldAlert size={48} color="#ef4444" className="role-guard-icon" />
          <h2 className="role-guard-title">
            Access Restricted
          </h2>
          <p className="role-guard-description">
            You do not have administrative privileges to access the Organization Configuration Panel. Please contact your organization administrator if you need access.
          </p>
          <a href="/" className="role-guard-btn">
            Return to Dashboard
          </a>
        </div>
      </div>
    );
  }

  return children;
};

export default RoleGuard;
